import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import './styles/components.css';

// Initialize the React application
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// Add global error handling
window.addEventListener('unhandledrejection', (event) => {
	console.error('Unhandled promise rejection:', event.reason);
	// You could show a user-friendly error message here
});

window.addEventListener('error', (event) => {
	console.error('Global error:', event.error);
	// You could show a user-friendly error message here
});

// Hot Module Replacement for development
if (module.hot) {
	module.hot.accept('./App', () => {
		const NextApp = require('./App').default;
		root.render(
			<React.StrictMode>
				<NextApp />
			</React.StrictMode>
		);
	});
}